import { useFieldContext } from '@/lib/forms/context'

import { Field, FieldContent, FieldError, FieldLabel } from '../ui/field'
import { NativeSelect, NativeSelectOption } from '../ui/native-select'

type Props = {
  label: string
  options: { value: string; label: string; disabled?: boolean }[]
}

export const SelectField = ({ label, options }: Props) => {
  const field = useFieldContext<string>()

  const isInvalid = field.state.meta.isTouched && !field.state.meta.isValid

  return (
    <Field data-invalid={isInvalid}>
      <FieldContent>
        <FieldLabel
          htmlFor={field.name}
          className="text-foreground text-base font-bold"
        >
          {label}
        </FieldLabel>
      </FieldContent>
      <NativeSelect
        name={field.name}
        value={field.state.value}
        onChange={(val) => field.handleChange(val.target.value)}
        selectClassName="h-12 border-muted bg-white focus-visible:ring-primary px-4"
      >
        {options.map((option) => (
          <NativeSelectOption
            key={option.value}
            value={option.value}
            disabled={option.disabled}
          >
            {option.label}
          </NativeSelectOption>
        ))}
      </NativeSelect>
      {isInvalid && <FieldError errors={field.state.meta.errors} />}
    </Field>
  )
}
